angular.module('picmonicng').factory('Tracks', [
  '$resource',
  function ($resource) {
    return $resource(
      '/api/v3/tracks/:track_id/:resource/:resource_id',
      {
        track_id: '@track_id',
        resource: '@resource',
        resource_id: '@resource_id',
      },
      {
        savev2: {
          method: 'POST',
          url: '/api/v2/tracks/:track_id/:resource/:resource_id',
          isArray: false,
        },
        deletev2: {
          method: 'DELETE',
          url: '/api/v2/tracks/:track_id/:resource/:resource_id',
          isArray: false,
        },
        query: { method: 'GET', url: '/api/v2/tracks', isArray: true },
        update: {
          method: 'PUT',
          url: '/api/v2/tracks/:track_id/:resource/:resource_id',
        },
        updatev3: {
          method: 'PUT',
          url: '/api/v3/tracks/:track_id/:resource/:resource_id',
        },
      }
    );
  },
]);
